import { Loader } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent, useEffect } from 'react'
import { useAppRouter, useAssessmentRequest, useCheckoutToken, useCreateFacilityAssessmentMutation, useProfilingId } from '../../state'
import { Route } from '../../config/router'
import { useMoneyHooks, usePCLDecline } from './hooks'

export const AffordabilityVerifying: FunctionComponent = () => {
  const { t } = useTranslation()
  const { push } = useAppRouter()
  const token = useCheckoutToken()
  const profilingSessionId = useProfilingId()
  const [createFacilityAssessment] = useCreateFacilityAssessmentMutation({
    fixedCacheKey: 'shared-facility-assessment',
  })
  const { handleDecline } = usePCLDecline()
  const { convertToMoney } = useMoneyHooks()
  const assessmentRequest = useAssessmentRequest()

  const callFacilityAssessment = async (): Promise<void> => {
    const { employmentStatus, maxCreditLimit, changeInCircumstances } = assessmentRequest
    const params = {
      token,
      profilingSessionId,
      maxFacilityLimit: convertToMoney(maxCreditLimit ?? ''),
      employmentStatus,
      changeInCircumstances,
    }
    try {
      const response = await createFacilityAssessment(params).unwrap()
      if (typeof response.incomeSources !== 'undefined') {
        push(Route.AFFORDABILITY_JOINT_ACCOUNTS)
      } else {
        push(Route.APPROVED_CREDIT)
      }
    } catch (e) {
      handleDecline()
    }
  }

  useEffect(() => {
    callFacilityAssessment()
  }, [])

  return <Loader text={t('consumerLending:affordability:verifying:loader')} />
}
